import React, { useState } from 'react';
import './Portfolio.css'
import {PortfolioData} from './PortfolioData'
import {PortfolioData2} from './PortfolioData'
import {PortfolioData3} from './PortfolioData'
import { Helmet } from 'react-helmet'

const Portfolio = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const handleImageClick = (image) => {
    setLightboxImage(image);
  }

  return (
    <div className='portoflio-container'>
      <Helmet>
				<title>Aliquam - Portfolio</title>
			</Helmet>
      <h1 className='phm'>POLISH HERITAGE IN MINECRAFT</h1>
      <div className="line"></div>

       <div className='portfolio'>
        {
          PortfolioData.map(({title, image, image_full}, index) => {
              return (
              <div className='portfilio-content' key={index} onClick={() => handleImageClick(image_full)}>
                  <img src={image} alt={title} loading="lazy"/>
                  <p>{title}</p>
              </div>
              )
          })
        }
      </div>
      <h1 className='ourpr'>OUR PROJECTS</h1>
       <div className='portfolio2'>
        <div className='portfolio-maps'>
          {
            PortfolioData2.map(({title, image, image_full}, index) => {
                return (
                <div className='portfilio-content2' key={index} onClick={() => handleImageClick(image_full)}>
                    <img src={image} alt={title} loading="lazy"/>
                    <p>{title}</p>
                </div>
                )
            })
          }
        </div>
        <div className='portfolio-skins'>
          {
            PortfolioData3.map(({title, image, image_full}, index) => {
                return (
                <div className='portfilio-content2 skins' key={index} onClick={() => handleImageClick(image_full)}>
                    <img className='portfilio-content2-img' src={image} alt={title} loading="lazy"/>
                    <p>{title}</p>
                </div>
                )
              })
           }
        </div>
      </div>
      {lightboxImage && (
        <div className="lightbox" onClick={() => setLightboxImage(null)}>
         <img src={lightboxImage} alt="lightbox" loading="lazy"/>
       </div>
      )}
    </div>
  )
}

export default Portfolio
